import { Link } from 'react-router-dom';

import { BRAND_NAME, LEGAL_URLS, NEW_TAB } from '../lib/brand.js';

/**
 * Terms - **the website is the master** (D-15, ruled 22 September 2026).
 *
 * The portal carried its own Terms from D-2 until Phase B, and D-14 Item 8.3
 * rewrote them. D-15 ends that: one set of words, maintained where the legal
 * and marketing copy already live, rather than two that drift. This route
 * survives as a line and a link so an old bookmark, an old email and the
 * sign-up line's own history all land somewhere useful rather than on a 404.
 *
 * **What the website page has to carry** was checked before this one was
 * retired, and the gaps are listed in PORTAL-BUILD-REPORT.md rather than
 * dropped: suspension and closure, how we contact you with the unsubscribe,
 * and account activity being logged.
 *
 * `TERMS_VERSION` in `server/src/brand.ts` names the **website** page's own
 * version string now, because that is the document somebody agreed to.
 */
export function TermsPage(): React.JSX.Element {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12">
      <Link to="/" className="text-sm text-fg-muted underline">
        Back to {BRAND_NAME}
      </Link>

      <h1 className="mt-4 text-2xl font-semibold tracking-tight text-fg">Terms</h1>

      <p className="mt-6 text-sm text-fg-2">
        Our Terms live on the {BRAND_NAME} website, so there is one copy of them and it is
        always the current one.
      </p>

      <p className="mt-4 text-sm">
        <a {...NEW_TAB} href={LEGAL_URLS.terms} className="font-medium text-fg underline">
          Read the Terms
        </a>
      </p>

      <p className="mt-6 text-sm text-fg-2">
        The{' '}
        <a {...NEW_TAB} href={LEGAL_URLS.privacy} className="underline">
          Privacy policy
        </a>{' '}
        and the{' '}
        <a {...NEW_TAB} href={LEGAL_URLS.refunds} className="underline">
          Refunds policy
        </a>{' '}
        are there too.
      </p>
    </div>
  );
}
